import { applicationPropertyApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const PROPERTY_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/properties`,
  {
    GET_PROPERTIES: 'GET_PROPERTIES',
    REMOVE_PROPERTY: 'REMOVE_PROPERTY',
  },
);

const propertiesSchema = new schema.Entity('data', {}, { idAttribute: 'propertyId' });

export const getPropertiesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationPropertyApi.getProperties(params);

  return dispatch({
    type: PROPERTY_ACTION_TYPE.GET_PROPERTIES,
    payload: normalize(data, [propertiesSchema]).entities.data,
  });
});

export const deletePropertyAction = params => async dispatch => {
  const { data } = await applicationPropertyApi.deleteProperty(params);

  return dispatch({
    type: PROPERTY_ACTION_TYPE.REMOVE_PROPERTY,
    meta: params,
    payload: data,
  });
};
